/* На каждый шаблон свой JS модуль */
import { PHP } from '../PHP';
import { FotoAlbom as Slider } from '../lib/albom';

//Общий объект для всех юнитов
window.unit = {};

window.unit.main = {
	init() {
		//const sliderBox = document.querySelector("header .albom");
		//var slider = new Slider(sliderBox);

		//Добавим авто смену фото в шапке
		// setInterval(()=>{
		// 	slider.next();
		// }, 5000);//время анимации в миллисекундах

		const albom = document.querySelector("article .albom");
		if (PHP.debug > 0) console.log('main.init()');
	
		boxCards = document.querySelector('.box');
		boxCards.addEventListener("click", (e) => {
			var t = e.target;
			if (!JED.tune.edit) {
				var pgId = t.getAttribute("data-pgid");
				var t2 = t;
				if (!pgId) {
					t2 = t.parentElement;
					pgId = t2.getAttribute("data-pgid");
				}
				if (!pgId) {
					t2 = t2.parentElement;
					pgId = t2.getAttribute("data-pgid");
				}
				var path = t2.getAttribute("data-path");
			}
		}, false);
	}
}